import { render, staticRenderFns } from "./OrganizationProjects.vue?vue&type=template&id=3aa2512f&scoped=true"
import script from "./OrganizationProjects.vue?vue&type=script&lang=js"
export * from "./OrganizationProjects.vue?vue&type=script&lang=js"
import style0 from "./OrganizationProjects.vue?vue&type=style&index=0&id=3aa2512f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa2512f",
  null
  
)

export default component.exports